import React, { useState, useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Select from "react-select";
import DatePicker, { DateObject } from "react-multi-date-picker";

import axios from 'axios';



const VendorPayment = ({ show, onClose }) => {

    const subledger_options = [
        { value: "0", label: "Rent Expense" },
        { value: "1", label: "Raw Material Expense" },
        { value: "2", label: "By Subscriptions Income" },
    ];


    const vendor_options = [
        { value: "0", label: "Mithra Grocery" },
        { value: "1", label: "krishan shop" },
    ];

    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const [hasFetched, setHasFetched] = useState(false);

    const [errors, setErrors] = useState({});
    const [itemcatErrors, setItemcatErrors] = useState({});
    const [isFocused] = useState(false);
    useEffect(() => {
        if (isFocused) {
            console.log('The input is focused!');
        }
    }, [isFocused]);

    const [vendor_date, setVendorDate] = useState(null);
    const handleDateChange = (dateValue) => {
        // Format the selected date to 'YYYY-MM-DD' and store it in the state
        // alert(dateValue);
        if (dateValue) {
          const formattedDate = dateValue.format('YYYY-MM-DD');
        // alert(formattedDate);

          setVendorDate(formattedDate);
        } else {
          setVendorDate(null);
        }
    };

    const [vendor_option, setSelectedVendorOption] = useState(null);
    const [vendorOption, setVendorOptions] = useState(null);
      useEffect(() => {
        const fetchvendor = async () => {
            try {
                const response = await axios.get(`${baseURL}/manage-daily-accounts/get-vendor`);
                const vendor = response.data.data.map(vendors => ({
                        label: vendors.vendor_businessname,
                        value: vendors.sno
                }));

                // console.log('vendor----------------',vendor);
                setVendorOptions(vendor);
                  setHasFetched(true);

            } catch (error) {
                console.error("Failed to fetch ledger:", error);
            }
        };
        fetchvendor();
    }, [baseURL]);

     const [out_amount, setOutAmount] = useState(null);
     const [amount, setAmount] = useState(null);
     const [raw_count, setRawCount] = useState(null);
     const [description, setDescription] = useState(null);


     useEffect(() => {
        if (vendor_option) {
        const fetchvendoramount = async () => {
                            try {
                                const response = await axios.get(`${baseURL}/manage-daily-accounts/get-amount-by-vendor/${vendor_option}`);
                                const out_amount = response.data.data;
                                // console.log('out_amount------------>',out_amount);
                                    setOutAmount(out_amount);
                            } catch (error) {
                                console.error("Failed to fetch ledger:", error);
                            }
                        };
                        fetchvendoramount();
        }
    }, [vendor_option]);

      const validateForm = () => {
        const formErrors = {};
        const itemcatValidationErrors = {};

        if (!vendor_date) {
            formErrors.vendor_date = "Vendor Date is required";
        }
        if (!vendor_option) {
            formErrors.vendor_option = "Vendor is required"; 
        }
        if (!out_amount) {
            formErrors.out_amount = "Outstanding amount is required"; 
        }
        
        if(!amount) {
            formErrors.amount = "Amount is required"; 
        }
        if(!description) {
            formErrors.description = "Description is required"; 
        }
       
        if (!raw_count) {
            formErrors.raw_count = "Rawmaterial count is required"; 
        }
       
        setErrors(formErrors);
        setItemcatErrors(itemcatValidationErrors);

        return Object.keys(formErrors).length === 0 && Object.keys(itemcatValidationErrors).length === 0;
    };
 

      const handleFormSubmit = async () => {
            const isValid = validateForm();
            if (!isValid) return;
    
            const dailyAccounts = {
                vendor_date: vendor_date,
                vendor_option: vendor_option,
                amount: amount,
                out_amount: out_amount,
                raw_count: raw_count,
                description:description
            };
    
            try {
                const response = await axios.post(`${baseURL}/manage-daily-accounts/accounts-vendor-create`, dailyAccounts);
                if (response.status === 201) {
                    // alert("Package created successfully!");
                    onClose();
                    //  navigate('/daily-accounts');
                    window.location.reload();
                }
            } catch (error) {
                console.log("Error creating package:", error.response?.data || error);
                // alert(error.response?.data?.message || "There was an error creating the package.");
            }
        };



    return (
        <Modal show={show} onHide={onClose} size="lg">
            <div className="modal-content border border-red rounded-xxl">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Add Vendor Payment</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row">
                        <div className="col-lg-6 mb-2">
                            <label className="text-black font-w500 fs-7">Date<span className="required">*</span></label>
                            <div className='datepicker-wrapper d-flex'>
                                <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                <DatePicker placeholder='Select Date'
                                    // value={selectedDate}
                                    onChange={handleDateChange}
                                    format="DD-MM-YYYY"
                                />
                            </div>
                             {errors.vendor_date && <span className="text-danger">{errors.vendor_date}</span>}
                        </div>
                        <div className="col-lg-6 mb-2">
                            <label className="text-black font-w500 fs-7">Vendor <span className="required">*</span></label>
                            <Select placeholder='Select Vendor'
                                // onChange={setSelectedOption}
                            // value={vendorOption.find(option => option.value === vendor_option)  || null}
                            onChange={(selectedOption) => setSelectedVendorOption(selectedOption.value)}
                                options={vendorOption}
                            />
                            {errors.vendor_option && <span className="text-danger">{errors.vendor_option}</span>}
                        </div>
                        <div className="col-lg-6 mb-2">
                            <label className="text-black font-w500 fs-7">Outstanding Amount <span className="required">*</span></label>
                            <input placeholder='Enter Outstanding Amount ' type="text" className="form-control" value={out_amount} readOnly={true} />
                            {errors.out_amount && <span className="text-danger">{errors.out_amount}</span>}
                        </div>
                        <div className="col-lg-6 mb-2">
                            <label className="text-black font-w500 fs-7">Raw Material Count <span className="required">*</span></label>
                            <input placeholder='Enter Raw Material Count' type="text" className="form-control" value={raw_count} onChange={(e) => { setRawCount(e.target.value); }} />
                            {errors.raw_count && <span className="text-danger">{errors.raw_count}</span>}
                        </div>
                        <div className="col-lg-6 mb-2">
                            <label className="text-black font-w500 fs-7">Amount <span className="required">*</span></label>
                            <input placeholder='Enter Amount' type="text" className="form-control" value={amount} onChange={(e) => { setAmount(e.target.value); }} />
                            {errors.amount && <span className="text-danger">{errors.amount}</span>}
                        </div>
                        
                        <div className="col-lg-6 mb-2">
                            <label className="text-black font-w500 fs-7">Description <span className="required">*</span></label>
                            <textarea  className="form-control" name="comment" placeholder="Description" value={description} onChange={(e) => { setDescription(e.target.value); }} />
                                {errors.description && <span className="text-danger">{errors.description}</span>}
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
                        <Link type="submit" className="btn btn-sm btn-primary" onClick={handleFormSubmit}>Add Vendor Payment
                            <i className="fas fa-angle-double-right ms-2"></i></Link>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default VendorPayment;
